import React from 'react';
import { Container, Wrap, WrapItem } from '@fiverr-private/layout_components';
import { PressReleasesHeader } from '../PressReleasesHeader';
import { SelectedPressRelease } from '../SelectedPressRelease';
import { Footer } from '../Footer';
import { PressRelease } from '../../../types/types';

interface SelectedPressReleasePageProps {
  selectedPressRelease: PressRelease;
}

export const SelectedPressReleasePage = ({ selectedPressRelease }: SelectedPressReleasePageProps) => (
  <Container borderBottomWidth="sm" borderColor="grey_500" borderStyle="solid" justifyContent="center">
    <Container
      marginX={{ lg: 'auto' }}
      padding={{ default: '5', md: '8' }}
      maxWidth={{ default: '100%', lg: '1400px' }}
    >
      <Wrap gap="5" marginBottom={selectedPressRelease ? '4' : '12'} marginTop={{ lg: '8' }}>
        <WrapItem flexBasis="100%" flexGrow={1}>
          <PressReleasesHeader />
        </WrapItem>
      </Wrap>
      <SelectedPressRelease selectedPressRelease={selectedPressRelease} />
    </Container>
    <Footer />
  </Container>
);
